import React from "react";

// A thin sticky shell around each page's existing header row (back button +
// icon + title/subtitle + search/actions). It intentionally does NOT
// prescribe the header's internal layout — every page keeps its own exact
// markup and styling — it only adds the sticky/background/stacking behavior
// so the same wrapper works for every page's header, whatever that header
// looks like inside.
//
// Positioning note: the app's own top navbar (".header" in MainLayout.css)
// already sits outside the scrollable area, so `top-0` here sticks a page
// header flush under it with no extra offset math needed — `.content` (the
// scrolling container every page renders inside) is the only ancestor that
// scrolls.
//
// Background note: the scrolling area behind every page is NOT pure white —
// it's `--main-content-bg` (a theme-tinted near-white set in
// MainLayout.css's `.layout-container`), and no page sets its own
// background either, so it inherits that same color. A plain `bg-white`
// here would sit at a visibly different shade once scrolled content passes
// underneath it, so this uses the same CSS variable instead of a Tailwind
// color class (which has no theme-aware equivalent) to stay exactly the
// color the header already blended into before it became sticky.
export default function PageHeader({ className = "", children }) {
  return (
    <div className={`sticky top-0 z-20 ${className}`} style={{ backgroundColor: "var(--main-content-bg)" }}>
      {children}
    </div>
  );
}
